import { motion } from "framer-motion";

/**
 * Animated, theme-aware offline-mode mockup: the library stays browsable with
 * no connection, and a queued save waits to sync. Replaces screenshots.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const softBadge = {
  background: "var(--mock-surface)",
  color: "var(--bs-secondary-color, var(--bs-secondary))",
  border: "1px solid var(--mock-border)",
};

export const OfflineMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--offline ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-wifi-off me-1" />
          You're offline
        </div>
      </div>

      <div className="obm-mock__body">
        <motion.div
          variants={item}
          className="small d-flex align-items-center mb-3 rounded-3 px-3 py-2"
          style={softBadge}
        >
          <i className="bi bi-cloud-slash me-2 text-warning" />
          No connection. Your library is still here
        </motion.div>

        <div className="obm-mock__list">
          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#047857" }}>
              R
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="text-truncate">React docs</div>
              <div className="small text-secondary text-truncate">
                react.dev/learn
              </div>
            </div>
            <span className="badge" style={softBadge}>
              <i className="bi bi-check2 me-1 text-success" />
              Cached
            </span>
          </motion.div>

          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#2563eb" }}>
              A
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="text-truncate">Deep-work article</div>
              <div className="small text-secondary text-truncate">
                blog.example.com/deep-work
              </div>
            </div>
            <span className="badge" style={softBadge}>
              <i className="bi bi-book me-1 text-success" />
              Readable
            </span>
          </motion.div>

          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#9333ea" }}>
              N
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="text-truncate">New bookmark saved offline</div>
              <div className="small text-secondary text-truncate">
                added just now
              </div>
            </div>
            <span className="badge bg-warning text-dark">
              <i className="bi bi-arrow-repeat me-1" />
              Will sync
            </span>
          </motion.div>
        </div>

        <motion.div
          variants={item}
          className="small text-secondary mt-3 d-flex align-items-center"
        >
          <i className="bi bi-arrow-repeat me-2 text-purple" />
          1 change queued. Syncs automatically when you're back online
        </motion.div>
      </div>
    </motion.div>
  );
};

export default OfflineMock;
